import React, { useState, useEffect } from "react";
import { main_server } from "../../constants";
import styles from "./index.module.css";
import { Spotlight } from "../../ui/spotlight";
import { Sparkels } from "../";

const ConfirmPhone = (props) => {
  const [code, setCode] = useState("");
  const [change, setChange] = useState(false);
  const [phone, setPhone] = useState(false);

  function isValidPhoneNumber(phoneNumber) {
    // Regex to check valid phone number.
    const pattern = /^[+]{1}(?:[0-9\-\\(\\)\\/.]\s?){6,15}[0-9]{1}$/;

    // If the phone number is empty return false
    if (!phoneNumber) {
        return "false";
    }

    // Return true if the phone number
    // matched the Regex
    if (pattern.test(phoneNumber)) {
        return "true";
    } else {
        return "false";
    }
}

async function handleButtonClick() {
  if (change) {
    if (!isValidPhoneNumber(code)) {
      props.setAlertText('Error ! Please enter a valid phone number !');
    props.setAlertType(false);
    props.setShowAlert(true);
    setTimeout(() => props.setShowAlert(false), 2500);
    return;
    }
  }
  const response = await fetch(
    `${main_server}${!change ? "verify" : "changePhone"}`,
    {
      method: "POST",
      headers: {
        "Content-Type": "text/plain",
        Authorization:
          "Bearer " + localStorage.getItem("chesscloud-token"),
      },
      body: JSON.stringify({ code }),
    },
  );
  const content = await response.text();
  if (response.status === 200) {
    if (change) {
      setCode("");
      setChange(false);
      props.setAlertType(true);
      props.setAlertText(
          "Phone number successfully changed",
      );
      props.setShowAlert(true);
      setTimeout(() => props.setShowAlert(false), 3000);
    } else {
      window.location.href = '/';
    }
  } else if (response.status === 401) {
    props.setAlertText('Error ! Please log in again !');
    props.setAlertType(false);
    props.setShowAlert(true);
    setTimeout(() => props.setShowAlert(false), 2500);
  }  else {
    props.setAlertType(false);
    props.setAlertText(
        "Unexpected error ! Please try again..",
    );
    props.setShowAlert(true);
    setTimeout(() => props.setShowAlert(false), 3000);
  }
}
  
  useEffect(() => {
    const query = new URLSearchParams(window.location.search);
    const mode = query.get('mode');
    if (typeof mode === 'string' && mode.length > 0) {
      if (mode === "phone") { setChange(true); setPhone(true); }
    }
  }, []);

  useEffect(() => {
    function handleKeyDown(event) {
      if (event.key === 'Enter') {
        handleButtonClick();
      }
    }

    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  return (
    <section className={`${styles.container} h-full pt-[100px]`}>
      <div className="px-4 mx-auto sm:px-6 lg:px-8 max-w-7xl">
        <div className="max-w-2xl mx-auto">
          {/* Decorative glowing elements */}
          <div className={`${styles.glow} ${styles.glow1}`}></div>
          <div className={`${styles.glow} ${styles.glow2}`}></div>
          
          <div className={styles.cardWrapper}>
            <Spotlight
              className="-top-40 left-0 md:left-60"
              fill="white"
              active={true}
            />
           
            <div className={`${styles.card} text-center`}>
            <h1 className={`${styles.title}`}>
              {!change
                ? props.lang === 0
                  ? "אמתו את מספר הטלפון שלכם"
                  : "Verify Your Phone Number"
                : props.lang === 0
                  ? "שנו את המספר שלכם"
                  : "Enter Your Phone Number"}
            </h1>
            <Sparkels />
            <p className={styles.subtitle}>
              {!change
                ? props.lang === 0
                  ? "שלחנו הודעת סמס למספר הטלפון שלכם. אנא אפשרו מספר רגעים להודעה להגיע."
                  : `We've sent an SMS with a verification code to your phone number.
                     Please enter it below. Allow a few moments for the SMS to arrive.`
                : props.lang === 0
                  ? "אנא הכניסו את מספר הטלפון הנכון שלכם כולל קידומת"
                  : "Please enter your correct phone number including country code"}
            </p>

            <form onKeyDown={(e) => e.key === 'Enter' && e.preventDefault()} className="mt-8">
              <div className={styles.formGrid}>
                <div className={styles.inputWrapper}>
                  <label htmlFor="verification-code" className="block mb-2 text-sm font-bold text-[#d8ecf8]">
                    {!change
                      ? props.lang === 0
                        ? "קוד אימות"
                        : "Verification Code"
                      : props.lang === 0
                        ? "מספר טלפון"
                        : "Phone Number"}
                  </label>
                  <input
                    type="text"
                    id="verification-code"
                    onChange={(e) => {
                      setCode(e.target.value);
                    }}
                    placeholder={
                      !change
                        ? props.lang === 0
                          ? "קוד אימות "
                          : "5-Digit Verification Code"
                        : props.lang === 0
                          ? "מספר טלפון"
                          : "Phone Number"
                    }
                    value={code}
                    className={styles.input}
                  />
                </div>

                <button
                  type="button"
                  className={styles.button}
                  style={{ cursor: 'pointer' }}
                  onClick={handleButtonClick}
                >
                  {!change
                      ? "Verify"
                      : (phone ? "Update Number" : "Change Number")}
                </button>
              </div>
            </form>

            <div className="mt-8 text-center">
              <p className="text-sm font-medium text-[#b8c5d1]">
                {!change &&
                  (props.lang === 0
                    ? "מספר טלפון שגוי ?"
                    : "Wrong phone number?")}
                {" "}
                <a
                  onClick={() => setChange(!change)}
                  title=""
                  className={styles.link}
                  style={{ cursor: 'pointer' }}
                >
                  {!phone && (!change
                    ? props.lang === 0
                      ? "שינוי מספר"
                      : "Change Number"
                    : props.lang === 0
                      ? "חזרו לאימות"
                      : "Return to Verification")}
                </a>
              </p>
            </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ConfirmPhone;
